import HttpService from '@/services/httpService';
import { getDirectionMeta } from '@/utils/global';

export default async function initializeApplication(): Promise<number> {
  const result = await new HttpService().httpInstance.get(`config-${getDirectionMeta().language}.json?v=${new Date().toISOString()}`);

  window.$config = result.data;

  return Promise.resolve(1);
}
